var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M23 6l-9.5 9.5-5-5L1 18"}}),_c('path',{attrs:{"d":"M17 6h6v6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }